import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import warehouseReducer from './slices/warehouseSlice';
import bookingReducer from './slices/bookingSlice';
import inventoryReducer from './slices/inventorySlice';
import billingReducer from './slices/billingSlice';
import notificationReducer from './slices/notificationSlice';
import spaceReducer from './slices/spaceSlice';
import operationsReducer from './slices/operationsSlice';
import disputeReducer from './slices/disputeSlice';
import logisticsReducer from './slices/logisticsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    warehouse: warehouseReducer,
    booking: bookingReducer,
    inventory: inventoryReducer,
    billing: billingReducer,
    notification: notificationReducer,
    space: spaceReducer,
    operations: operationsReducer,
    dispute: disputeReducer,
    logistics: logisticsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/verifyOtp/fulfilled'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
